import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-pagina-detalhes',
  standalone: false,
  templateUrl: './pagina-detalhes.component.html',
  styleUrl: './pagina-detalhes.component.css'
})
export class PaginaDetalhesComponent implements OnInit {
  id: string;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.id = params['id'];
    });
  }

  protected readonly Number = Number;
}
